<template>
  <default-layout>
    <event-navbar title="Exhibitor" />
    <div class="container-fluid">
      <div v-if="showBackButton" class="py-2">
        <button class="btn btn-outline-secondary btn-sm rounded-pill" type="button" @click="goBackToVisitorLeads">
          {{ backToContactsLabel }}
        </button>
      </div>
      <exhibitor-detail :exhibitorId="$route.params.exhibitorId" exhibitor-type="exhibitor"/>
    </div>
  </default-layout>
</template>

<script>
// @ is an alias to /src
import ExhibitorDetail from '@/components/exhibitor/exhibitor-detail.vue'
import EventNavbar from '@/components/EventNavbar.vue'
import DefaultLayout from '@/components/DefaultLayout.vue'
import { translateVisitorLead } from '@/components/visitor-lead/i18n.js'

export default {
  name: 'ExhibitorDetailView',
  components: {
    ExhibitorDetail, EventNavbar, DefaultLayout
  },
  computed: {
    showBackButton() {
      return this.$route.query.from === 'ExhibitorScanView'
    },
    backToContactsLabel() {
      return translateVisitorLead('actions.backToContacts')
    }
  },
  methods: {
    goBackToVisitorLeads() {
      this.$router.go(-1)
    }
  }
}
</script>
